import { connect } from 'react-redux';
import SchemaSpecOverviewTab from './SchemaSpecOverviewTab';
import { isReadOnly } from '../../../lib/ACLUtils';
import { fetchSchemaSpecDoc, updateSchemaSpecDoc } from '../../../actions';
import { GET_SCHEMA_SPEC_DOC_REQUEST } from '../../../constants/actionTypes';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { docs },
    schemaSpecs: { docById, lastUpdated },
  } = state;
  const { data } = ownProps;
  const readOnly = isReadOnly(data);

  return {
    readOnly,
    doc: data && docById[data.id] && docs[docById[data.id]] ? docs[docById[data.id]].text : null,
    isLoadingDoc: !!request[GET_SCHEMA_SPEC_DOC_REQUEST],
    lastUpdated,
  };
};

export default connect(mapStateToProps, {
  fetchSchemaSpecDoc,
  updateSchemaSpecDoc,
})(SchemaSpecOverviewTab);
